export const PHONE_MIN_LENGTH = 10;
export const LANDLINE_VALID_FIRST_NUMBERS = [2, 3, 4, 5];
